import styled from 'styled-components';

export const StraightBarStyle = styled.div`
  width: 3px;
  height: 22px;
  background-color: #fd82c3;
  border-radius: 4px;
`;
